<template>
	<report-page
		:start-date="false"
		:end-date="false"
		get-url="/bo/report/finance/transactionreserves"
		title="Customer Balance"
		export-filename="users_reserves"
		:show="false"
	/>
</template>

<script>
export default {
	name: 'TransactionReservesReport'
};
</script>

<style scoped>

</style>
